// hooks/useGlobalInteractionListener.js

import type { USER_INTERACTION_DATA_ATTRIBUTE } from "@shared/constants";
import { useEffect } from "react";

type EventNames = keyof DocumentEventMap;

export const useGlobalInteractionListener = (
	dataAttribute: typeof USER_INTERACTION_DATA_ATTRIBUTE,
	callback: (
		event: Event,
		target: HTMLElement,
		eventType: Event["type"],
	) => void,
) => {
	useEffect(() => {
		const handleEvent = (event: Event) => {
			const target: HTMLElement | null = (
				event?.target as HTMLElement
			)?.closest(`[${dataAttribute}]`);

			if (target) {
				callback(event, target, event.type);
			}
		};

		// Listen to all relevant interaction events
		const events: EventNames[] = [
			"click",
			"keydown",
			"submit",
			"toggle",
			"change",
		];

		events.forEach((eventType) => {
			document.addEventListener(eventType, handleEvent);
		});

		return () => {
			events.forEach((eventType) => {
				document.removeEventListener(eventType, handleEvent);
			});
		};
	}, [dataAttribute, callback]);
};
